// extracted by mini-css-extract-plugin
export default {"switch":"customCheckbox_switch__ugD4p","slider":"customCheckbox_slider__cLBPD","round":"customCheckbox_round__eJHDn"};